
export default {
  props: {
    store: {type: Object, required: true},
    maxItems: {type: Number, default: 100}
  },
  emits: ['update'],
  data() {
    return {
      validation_error: ''
    }
  },
  computed: {
    my_store() {
      return this.store
    },
    preferred_sources: {
      get() {
        return this.my_store.preferred_sources || []
      },
      set(value) {
        const current = this.my_store.preferred_sources || []
        const normalized = value.map(domain => this.normalizeDomain(domain)).filter(Boolean)
        const added = normalized.filter(domain => !current.includes(domain))

        const invalid = added.find(domain => !this.isValidDomain(domain))
        if (invalid !== undefined) {
          this.validation_error = `Enter a valid domain, e.g. lightreading.com. “${invalid}” was not added.`
          return
        }

        if (new Set(normalized).size !== normalized.length) {
          // this.validation_error = 'That domain has already been added.'
          return
        }

        this.validation_error = ''
        this.my_store.preferred_sources = normalized
        this.$emit('update')
      }
    }
  },
  methods: {
    normalizeDomain(value) {
      const domain = value.trim().toLowerCase()
      const has_protocol = this.hasProtocol(domain)
      const without_protocol = domain.replace(/^[a-z][a-z\d+.-]*:\/\//i, '')
      return has_protocol ? without_protocol.replace(/^www\./i, '') : without_protocol
    },
    hasProtocol(value) {
      return /^[a-z][a-z\d+.-]*:\/\//i.test(value)
    },
    isValidDomain(value) {
      if (typeof value !== 'string' || value.length > 253 || this.hasProtocol(value)) return false

      const labels = value.split('.')
      if (labels.length < 2) return false

      const label_pattern = /^(?!-)[a-z\d-]{1,63}(?<!-)$/i
      return labels.every(label => label_pattern.test(label))
        && /^(?:[a-z]{2,63}|xn--[a-z\d-]{2,59})$/i.test(labels.at(-1))
    }
  }
}
